<nav class="nav">
  <ul class="nav-list">
    <li class="nav-item users-item">
      <a routerLink="/users"><fa-icon [icon]="usersIcon"></fa-icon>Users</a>
    </li>
    <li class="nav-item weather-item">
      <a routerLink="/weather">
        <fa-icon [icon]="weatherIcon"></fa-icon>Weather</a
      >
    </li>
    <li class="nav-item recipes-item">
      <a routerLink="/recipes"
        ><fa-icon [icon]="recipesIcon"></fa-icon>Recipes</a
      >
    </li>
  </ul>
</nav>
